import { Description, Dvr, TrendingUp } from "@mui/icons-material";
import IReport from "../interfaces/IReport";
import RoomOverviewFilters from "../pages/Admin/Governance/Reports/RoomOverview/Filters";
import RoomOverviewContent from "../pages/Admin/Governance/Reports/RoomOverview/Content";
import RoomLogFilters from "../pages/Admin/Governance/Reports/RoomLog/Filters";
import RoomLogContent from "../pages/Admin/Governance/Reports/RoomLog/Content";
import StatisticalLogFilters from "../pages/Admin/Governance/Reports/StatisticalLog/Filters";
import StatisticalLogContent from "../pages/Admin/Governance/Reports/StatisticalLog/Content";


const Reports: IReport[] = [
    {
        title: "roomOverview",
        subtitle: '_roomOverviewDescription',
        Icon: Dvr,
        alias: 'Governance.Reports.RoomOverview',
        Filters: RoomOverviewFilters,
        Content: RoomOverviewContent,
    }, {
        title: "roomLog",
        subtitle: '_roomLogDescription',
        Icon: Description,
        alias: 'Governance.Reports.RoomLog',
        Filters: RoomLogFilters,
        Content: RoomLogContent,
    }, {
        title: "statisticalLog",
        subtitle: '_statisticalLogDescription',
        Icon: TrendingUp,
        alias: 'Governance.Reports.StatisticalLog',
        Filters: StatisticalLogFilters,
        Content: StatisticalLogContent,
    }
];

export default Reports;


export const ReportsAlias = {
    Governance: {
        RoomOverview: 'Governance.Reports.RoomOverview',
        RoomLog: 'Governance.Reports.RoomLog',
        StatisticalLog: 'Governance.Reports.StatisticalLog'
    }
};